import type { FC } from "react";
import React from "react";

import { LoadingView } from "@react/foundation/placeholder";

export const LoadingViewDemo: FC = () => <LoadingView />;
